<template>
    <div>
        <div :class="[ expandable ? 'panel--expand' : 'panel' ]">
            <div class="panel__header">
                <h2>
                    <i class="panel__header__icon icons icon-equalizer"></i>
                    <span>{{$t('dashboard.tests.title')}}</span>
                </h2>
                <div @click.prevent="addNew" class="panel_header__action">
                    <i class="panel_header__action__icon icons icon-plus"></i>
                    <a class="button--link hidden-xs">{{$t('dashboard.tests.add_new')}}</a>
                </div>
            </div>

            <div class="panel__body" :class="{expanded}">
                <div v-if="loading">
                    <div class="spinner"></div>
                </div>
                <div v-else-if="!testItems.length" class="panel--empty">
                    <center>{{$t('dashboard.tests.no_tests')}}</center>
                </div>
                <div v-else class="panel__list">
                    <tests-item v-for="item in testItems" :key="item.id" :item="item" />
                </div>
            </div>

            <div v-if="expandable" class="panel__btn-expand" @click="togglePanelExpansion">
                <div v-if="expanded"><i class="icons icon-arrow-up"></i>{{$t('dashboard.tests.see_less')}}</div>
                <div v-else><i class="icons icon-arrow-down"></i>{{$t('dashboard.tests.see_all')}}</div>
            </div>
        </div>
        <test-modal />
    </div>
</template>

<script>
    import Vue from 'vue';
    import { Component, Prop } from 'vue-property-decorator';
    import TestsItem from './TestsItem';
    import TestModal from '@/components/modals/dashboard/TestModal';

    import { GET_TESTS } from '@/store/modules/tests';

    import Test from '@/models/Test';

    @Component({
        components: {
            TestsItem,
            TestModal,
        }
    })
    export default class TestsPanel extends Vue {
        name = 'tests-panel';
        expanded = false;

        created() {
            this.$store.dispatch(GET_TESTS, {});
        }

        get loading() {
            return this.$store.state.tests.loading;
        }

        get testItems() {
            return this.$store.state.tests.tests;
        }

        togglePanelExpansion() {
            this.expanded = !this.expanded;
        }

        get expandable() {
            return this.testItems.length && this.testItems.length > 2;
        }

        addNew() {
            const url = `/trajectories/${this.$store.state.trajectory.trajectory.id}/tests`;
            const test = new (Test.makeModel(url));
            this.$modal.show('test-modal', { test });
        }
    }

</script>



// WEBPACK FOOTER //
// src/components/panels/dashboard/TestsPanel.vue